import { render, staticRenderFns } from "./AddPay.vue?vue&type=template&id=4e0fbd7f&"
import script from "./AddPay.vue?vue&type=script&lang=js&"
export * from "./AddPay.vue?vue&type=script&lang=js&"
import style0 from "./AddPay.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports